module.exports = __webpack_public_path__ + "media/images/flags/zm-79cd9062e357592a77935bce1fb2dbd9.svg";